import React from 'react';
import clsx from 'clsx';
import Card from './Card';
import TrustMini from './TrustMini';

const Aside = ({
  className,
  children,
  showSocialProof,
  hideSocialProof,
  reducedPadding,
}: {
  className?: string;
  children: React.ReactNode;
  showSocialProof?: boolean;
  hideSocialProof?: boolean;
  reducedPadding?: boolean;
}): JSX.Element => (
  <aside className="w-aside ml-30">
    <Card
      className={clsx('hidden lg:block flex-shrink-0 mb-30', className)}
      style={
        reducedPadding
          ? { paddingTop: '25px', paddingBottom: '25px' }
          : undefined
      }
      aside={true}
    >
      {showSocialProof && !hideSocialProof ? <TrustMini /> : null}
      {children}
    </Card>
    {!showSocialProof && !hideSocialProof ? <TrustMini /> : null}
  </aside>
);

export default Aside;
